var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"visible":_vm.visible,"title":_vm.title},on:{"close":function($event){return _vm.close()}}},[_c('iframe',{style:({display: _vm.visible ? 'block' : 'none'}),attrs:{"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }